<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15L4YXN/tc-custom/9781611215892.jpg?1713957182513" alt="This image is the cover for the book Thirteen Months in Dixie, or, the Adventures of a Federal Prisoner in Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirteen Months in Dixie, or, the Adventures of a Federal Prisoner in Texas
      </h1>
      <p class="bookDescription body article font2">
        <b>A Union soldier recounts his capture and daring escape from a Texas POW camp in this rollicking Civil War memoir.</b><br/><br/>Oscar Federhen was a new recruit to the Union Army when he deployed to Louisiana as part of the Red River Campaign. Captured soon after his arrival at the front, Federhen was marched to Tyler, Texas, where he was held at Camp Ford, the largest POW camp west of the Mississippi.<br/><br/>The captured artillerist tried escaping several times, facing sadistic guards and vicious hounds, until he finally succeeded. Making his way through northeast Texas to reach Union lines, Federhen had to dodge regular Confederates, brigands, and even Comanches in his effort to get home. He rode for a time with Rebel irregular cavalry, during which he witnessed robberies and even cold-blooded murder. When he was recaptured and thought to be a potential deserter, he escaped yet again and continued his bid for freedom. <br/><br/>Federhen wrote this lively memoir shortly after the war, but it remained unpublished until Jeaninne Surette Honstein and Steven Knowlton carefully transcribed and annotated his manuscript. With numerous illustrations, including two by Federhen himself, <i>Thirteen Months in Dixie </i>is a gripping true story and a valuable primary source about the lives of Civil War prisoners and everyday Texans during the conflict.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeaninne Surette Honstein, Steven A. Knowlton, W. F. Oscar Federhen
      </h2>
      
      <p class="authorDescription body article">Jeaninne Honstein is a conceptual artist based in Princeton, New Jersey. Her paintings, sculpture, photography, and writing are influenced by her perception of history and antiquities. She is pleased to bring the story of her ancestor William Francis Oscar Federhen to the attention of the reading public for the first time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9fd624f8